import { MarketingNav } from '@/components/layout/marketing-nav'
import { SiteFooter } from '@/components/layout/site-footer'
import { PageMeta } from '@/components/seo/page-meta'
import { PELGO_ZOOM_SUPPORT_SEO } from '@/lib/pelgo-seo'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

const SUPPORT_EMAIL = 'support@pelgo.com'
const MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('Pelgo for Zoom support request')}`
const linkClass = 'text-blue-600 hover:underline'

export function ZoomSupportPage() {
  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <PageMeta config={PELGO_ZOOM_SUPPORT_SEO} />
      <MarketingNav variant="standalone" />

      <main className="container max-w-4xl py-12 px-4 pt-32 flex-1">
        <h1 className="text-4xl font-medium text-slate-900 mb-4">Pelgo for Zoom: Support</h1>
        <p className="text-slate-700 leading-relaxed mb-10">
          The Pelgo app for Zoom lets coaches on the Pelgo platform create and manage Zoom meetings
          for their coaching sessions. If you need help adding, using, or removing the app, our
          support team is here to help.
        </p>

        <div className="space-y-10">
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">Hours of operation</h2>
            <p className="text-slate-700 leading-relaxed">
              Monday through Thursday, Eastern Time (ET):
            </p>
            <ul className="list-disc pl-6 mt-2 text-slate-700 space-y-1">
              <li>9:00 AM to 12:00 PM ET</li>
              <li>9:00 PM to 12:00 AM ET</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">First response time</h2>
            <p className="text-slate-700 leading-relaxed">
              We answer inquiries within <strong>24 hours</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">Contact support</h2>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>
                <strong>Create a support case:</strong>{' '}
                <Link to="/contact" className={linkClass}>
                  submit a request through our contact form
                </Link>
                . Please mention that it is about Pelgo for Zoom.
              </li>
              <li>
                <strong>Email support:</strong>{' '}
                <a href={MAILTO} className={linkClass}>
                  {SUPPORT_EMAIL}
                </a>
              </li>
              <li>
                <strong>Knowledge base:</strong>{' '}
                <Link to="/zoom/docs" className={linkClass}>
                  Pelgo for Zoom documentation
                </Link>{' '}
                (adding, using, removing the app, troubleshooting, and FAQ)
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">When you contact us</h2>
            <p className="text-slate-700 leading-relaxed">
              To help us resolve your issue quickly, include the email address of your Pelgo coach
              account, the email address of the Zoom account you connected, and a description of
              what happened, including any message shown on screen. Never send passwords.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">Related policies</h2>
            <p className="text-slate-700 leading-relaxed">
              <Link to="/privacy" className={linkClass}>
                Privacy Notice
              </Link>{' '}
              and{' '}
              <Link to="/terms-of-service" className={linkClass}>
                Terms of Service
              </Link>
              .
            </p>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  )
}
